<!--
 * @Description: 添加用户-单个
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-26 17:01:47
-->
<template>
  <div>
    <p
      style="text-align:center;color:#696969;margin-bottom:30px"
      v-if="!editUserTag"
    >
      添加后的用户本月项目将被直接邀请加入项目。
    </p>

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
    >
      <el-form-item :label="['姓名', '经营者'][type] + '：'" prop="fullName">
        <el-input
          :disabled="editUserTag"
          v-model.trim="ruleForm.fullName"
          :maxlength="20"
          style="width:230px"
          :placeholder="`请输入${['姓名', '经营者'][type]}`"
        />
      </el-form-item>
      <el-form-item label="手机号：" prop="phone">
        <el-input
          :disabled="editUserTag"
          v-model.trim="ruleForm.phone"
          :maxlength="11"
          style="width:230px"
          placeholder="请输入手机号"
        />
      </el-form-item>
      <el-form-item label="个体名称：" prop="enterpriseName" v-if="type">
        <el-input
          :disabled="editUserTag"
          v-model.trim="ruleForm.enterpriseName"
          :maxlength="30"
          style="width:230px"
          placeholder="请输入个体名称"
        />
      </el-form-item>
      <personLabel :dataObj="ruleForm"></personLabel>
    </el-form>
    <div class="xrk-dialog__btns">
      <el-button type="info" @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </div>
  </div>
</template>

<script>
import { checkPhone } from '@/tools/formCheck';
import { checkoutPhone } from '@/methods/unqualified';
import { projectPersonnelManagement } from '@/api/ajax';
// 人员标签
import personLabel from '../../components/personLabel/personLabel.vue';

export default {
  name: 'AddUser',
  inject: ['_parent'], // src\page\project-personnel-inside\list\index.vue
  props: {
    editUserTag: {
      type: Boolean,
      default: false
    },
    defaultObj: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ruleForm: {
        fullName: '',
        phone: '',
        enterpriseName: ''
      },
      rules: {
        fullName: [
          {
            required: !this.editUserTag,
            message: `请输入${['姓名', '经营者'][this.type] || '姓名'}`,
            trigger: 'blur'
          }
        ],
        phone: this.editUserTag
          ? []
          : [
              {
                required: true,
                message: '请输入手机号',
                trigger: 'blur'
              },
              {
                validator: checkPhone,
                message: '请输入有效的手机号',
                trigger: 'blur'
              },
              {
                validator: checkoutPhone,
                trigger: 'blur'
              }
            ],
        enterpriseName: [
          {
            required: !this.editUserTag,
            message: '请输入个体名称',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  components: { personLabel },
  watch: {},
  computed: {
    // 0为人 1为个体
    type() {
      let obj = JSON.parse(localStorage.getItem('homeProject'));
      return obj.projectStructureType === 2 ? 1 : 0;
    }
  },
  methods: {
    cancel() {
      this.$xrkDialog.remove();
    },
    confirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.addUser();
        }
      });
    },
    addUser() {
      let data = {
        projectId: this.$route.query.id,
        ...this.ruleForm
      };
      const { editUserTag } = this;
      projectPersonnelManagement[
        editUserTag ? 'modifyUserTag' : 'addedIndividually'
      ](data).then(params => {
        if (params.data.code === '1') {
          this.$message.success(editUserTag ? '修改成功' : '添加成功');
          try {
            this._parent.$children[0].searchEvent(); //使用了tableRender的上下文
          } catch (err) {
            this._parent.tableSearch();
          }
          this.$xrkDialog.remove();
        }
      });
    }
  },
  created() {
    if (this.editUserTag) {
      this.ruleForm = {
        ...this.ruleForm,
        ...this.defaultObj
      };
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
</style>
